/* eslint-disable react/jsx-props-no-spreading */

const JulesBookshelf = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
    viewBox="0 0 73 67"
  >
    <path
      fill="#374151"
      d="M9 0h35.558A2.442 2.442 0 0147 2.442V67H9V0z"
    ></path>
    <path
      fill="#1F2937"
      d="M0 2.442A2.442 2.442 0 012.442 0H9v67H0V2.442z"
    ></path>
    <path fill="#1F2937" d="M13 3H43V19H13z"></path>
    <path fill="#1F2937" d="M13 23H43V40H13z"></path>
    <path fill="#1F2937" d="M13 44H43V61H13z"></path>
    <path
      fill="#6B7280"
      d="M13 26h2.43a.57.57 0 01.57.57V40h-3V26zM13 5h2.43a.57.57 0 01.57.57V19h-3V5zM13 47h2.43a.57.57 0 01.57.57V61h-3V47zM19 26h2.43a.57.57 0 01.57.57V40h-3V26zM19 5h2.43a.57.57 0 01.57.57V19h-3V5zM19 47h2.43a.57.57 0 01.57.57V61h-3V47zM25 26h2.43a.57.57 0 01.57.57V40h-3V26zM25 47h2.43a.57.57 0 01.57.57V61h-3V47zM31 26h2.43a.57.57 0 01.57.57V40h-3V26zM31 47h2.43a.57.57 0 01.57.57V61h-3V47zM37 26h2.43a.57.57 0 01.57.57V40h-3V26zM37 47h2.43a.57.57 0 01.57.57V61h-3V47z"
    ></path>
    <path
      fill="#4B5563"
      d="M16 26h2.43a.57.57 0 01.57.57V40h-3V26zM16 5h2.43a.57.57 0 01.57.57V19h-3V5zM16 47h2.43a.57.57 0 01.57.57V61h-3V47zM22 26h2.43a.57.57 0 01.57.57V40h-3V26zM22 47h2.43a.57.57 0 01.57.57V61h-3V47zM28 26h2.43a.57.57 0 01.57.57V40h-3V26zM28 47h2.43a.57.57 0 01.57.57V61h-3V47zM34 26h2.43a.57.57 0 01.57.57V40h-3V26zM34 47h2.43a.57.57 0 01.57.57V61h-3V47zM40 26h2.43a.57.57 0 01.57.57V40h-3V26zM40 47h2.43a.57.57 0 01.57.57V61h-3V47z"
    ></path>
    <g filter="url(#filter0_d_13334_22814)">
      <path
        stroke="#6B7280"
        strokeLinecap="round"
        strokeWidth="5.506"
        d="M51 31.5s-11 2-8.5 16"
      ></path>
    </g>
    <path
      fill="#4B5563"
      d="M60.578 27.953c-3.46.935-6.452-.167-8.278-1.361-.674-.441-1.656-.255-1.991.478L32.758 65.364A1.155 1.155 0 0033.808 67h31.886c.695 0 1.233-.61 1.146-1.3l-4.624-36.73c-.096-.762-.896-1.217-1.638-1.017z"
    ></path>
    <path
      stroke="#374151"
      strokeLinecap="round"
      strokeWidth="0.688"
      d="M53.526 27.702s-7.7 19.65-12.232 38.925"
    ></path>
    <ellipse
      cx="1.032"
      cy="1.183"
      fill="#374151"
      rx="1.032"
      ry="1.183"
      transform="matrix(.9615 .27482 -.27868 .96038 53.438 32.386)"
    ></ellipse>
    <ellipse
      cx="1.032"
      cy="1.183"
      fill="#374151"
      rx="1.032"
      ry="1.183"
      transform="matrix(.9615 .27482 -.27868 .96038 51.375 39.191)"
    ></ellipse>
    <ellipse
      cx="57.181"
      cy="16.241"
      fill="#6B7280"
      rx="8.775"
      ry="8.431"
      transform="rotate(21.05 57.18 16.241)"
    ></ellipse>
    <path
      fill="#fff"
      d="M51.123 14.156c-.118.441.032.934.416 1.371.384.437.97.782 1.632.96.661.177 1.342.171 1.893-.015.551-.187.927-.539 1.045-.98l-2.493-.668-2.493-.668z"
    ></path>
    <ellipse
      cx="49.912"
      cy="13.538"
      fill="#1F2937"
      rx="1.377"
      ry="1.549"
      transform="rotate(21.05 49.912 13.538)"
    ></ellipse>
    <ellipse
      cx="57.463"
      cy="15.982"
      fill="#1F2937"
      rx="1.377"
      ry="1.549"
      transform="rotate(21.05 57.463 15.982)"
    ></ellipse>
    <path
      fill="#1F2937"
      d="M41.954 8.84l-.075-.134-.055-.063-8.802-5.19a1.194 1.194 0 00-1.654.454l-5.84 10.645c-.299.547-.128 1.232.394 1.573l8.77 5.733L41.954 8.84z"
    ></path>
    <path
      fill="#FFFBEB"
      d="M32.883 3.97l9.047 5.223-1.91 1.284-9.116-5.243c1.147-1.196 1.979-1.265 1.979-1.265z"
    ></path>
    <path
      fill="#4B5563"
      d="M40.207 9.293l-8.272-4.776a2.09 2.09 0 00-2.854.765l-5.59 9.684a2.09 2.09 0 00.773 2.86l8.25 4.706 7.693-13.239z"
    ></path>
    <path
      fill="#6B7280"
      d="M32.582 10.6c.524-.538 1.418-.012 1.204.707l-.345 1.158a.72.72 0 00.187.72l.864.843c.537.525.012 1.419-.708 1.204l-1.157-.344a.72.72 0 00-.72.187l-.844.863c-.525.538-1.418.012-1.204-.708l.345-1.157a.72.72 0 00-.187-.72l-.864-.843c-.537-.525-.012-1.419.708-1.204l1.157.344a.72.72 0 00.72-.187l.844-.863z"
    ></path>
    <path
      fill="#4B5563"
      d="M40.185 9.313l1.516-.26a.238.238 0 00.12-.41.55.55 0 01.159.704L35.4 21.57a2.218 2.218 0 01-2.889.96l7.673-13.218z"
    ></path>
    <g filter="url(#filter1_d_13334_22814)">
      <path
        stroke="#6B7280"
        strokeLinecap="round"
        strokeWidth="5.506"
        d="M34.761 20.024S36.5 39.5 57.605 32.35"
      ></path>
    </g>
    <path
      fill="#D1D5DB"
      fillRule="evenodd"
      d="M49.107 11.341a9.7 9.7 0 011.17-2.623c-.887-2.37-.52-4.968 2.65-6.068 2.987-1.038 5.141 1.135 6.162 2.816.712.15 1.46.372 2.248.672.613.233 1.168.496 1.668.782 2.13-1.008 4.63-.944 6.35 1.603 2.016 2.981-.633 5.687-2.152 6.671-.1 1.028-.345 1.925-.61 2.562a.235.235 0 01-.297.128l-16.883-5.967a.477.477 0 01-.306-.576z"
      clipRule="evenodd"
    ></path>
    <defs>
      <filter
        id="filter0_d_13334_22814"
        width="15.108"
        height="22.159"
        x="38.646"
        y="28.095"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feOffset dx="-0.733" dy="-0.651"></feOffset>
        <feComposite in2="hardAlpha" operator="out"></feComposite>
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix>
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_13334_22814"
        ></feBlend>
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_13334_22814"
          result="shape"
        ></feBlend>
      </filter>
      <filter
        id="filter1_d_13334_22814"
        width="29.084"
        height="20.061"
        x="31.275"
        y="16.619"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feOffset dx="-0.733" dy="-0.651"></feOffset>
        <feComposite in2="hardAlpha" operator="out"></feComposite>
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix>
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_13334_22814"
        ></feBlend>
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_13334_22814"
          result="shape"
        ></feBlend>
      </filter>
    </defs>
  </svg>
);
export default JulesBookshelf;
